import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import {
  Text,
  Box,
  IconButton,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  VStack,
  useDisclosure,
  Tooltip,
} from '@chakra-ui/react';

import { AddIcon } from '@chakra-ui/icons';
import { MdQuiz } from 'react-icons/md';

import { subquestActions } from 'store/modules/subquest/subquest-slice';
import CreateInteractiveContentMd from 'components/subQuest/modals/interactiveContents/CreateInteractiveContentMd';
import CreateVideoMd from './modals/videos/CreateVideoMd';
import CreateNarrativeMd from './modals/narrative/CreateNarrativeMd';
import CreateFileSubmissionMd from './modals/fileSubmissions/CreateFileSubmissionMd';

function AddSubQuestMd({ isEditable, quest, courseId }) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const dispatch = useDispatch();

  const createQuizSubQuest = () => {
    dispatch(subquestActions.setQuest(quest));
    window.open(
      `/admin/quizzes/create?courseId=${courseId}&questId=${quest.id}`,
      '_blank'
    );
    onClose();
  };

  return (
    <>
      <Tooltip label="Add sub-quest">
        <IconButton
          display={isEditable ? 'block' : 'none'}
          onClick={onOpen}
          variant="plain"
          aria-label="Add Sub-Quest"
          icon={<AddIcon />}
        />
      </Tooltip>

      <Modal isOpen={isOpen} onClose={onClose} size="lg" isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Create Sub-Quest</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Box mb={10}>
              <Text mb={5}>
                Select which type of sub-quest you wish to create
              </Text>

              <VStack align="stretch" gap="4">
                <CreateVideoMd quest={quest} />
                <CreateNarrativeMd quest={quest} />
                <CreateInteractiveContentMd quest={quest} />
                <Button
                  leftIcon={<MdQuiz />}
                  w="100%"
                  colorScheme="red"
                  size="lg"
                  onClick={() => {
                    createQuizSubQuest();
                  }}
                >
                  Quiz
                </Button>
                <CreateFileSubmissionMd quest={quest} />
              </VStack>
            </Box>
          </ModalBody>

          <ModalFooter>
            <Button
              colorScheme="teal"
              variant="outline"
              outline
              mr={3}
              onClick={onClose}
            >
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}

AddSubQuestMd.propTypes = {
  isEditable: PropTypes.bool.isRequired,
  quest: PropTypes.object.isRequired,
  courseId: PropTypes.number.isRequired,
};

export default AddSubQuestMd;
